import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";
import { useUserStore } from "@/store";

export const tableConfig: TableHeaderConfig[] = [
  {
    prop: "mukoFlg",
    label: "無効",
    width: ColWidth.mini,
    class: "muko",
  },
  {
    prop: "groupId",
    label: "会社グループID",
    width: ColWidth.md,
  },
  {
    prop: "groupNm",
    label: "会社グループ名",
  },
  {
    prop: "kaishaCd",
    label: "会社コード",
    width: ColWidth.sm,
  },
  {
    prop: "kaishaNm",
    label: "会社名",
  },
  {
    prop: "unyoNm",
    label: "運用区分",
    width: ColWidth.sm,
  },
  {
    prop: "createdDate",
    label: "登録日時",
    width: ColWidth.lg,
  },
  {
    prop: "updatedDate",
    label: "更新日時",
    width: ColWidth.lg,
  },
];

export const filterTableConfig = (tableConfig: TableHeaderConfig[]) => {
  const userStore = useUserStore();
  if (userStore.isShinseisha) {
    tableConfig = tableConfig.filter((item) => item.prop !== "kaishaCd");
  }
  return tableConfig;
};
